import {
  IExperienceInclusionDetails,
  INavMenuItem,
} from '../models/interfaces/IInclusion';

import { ANALYTIC_CMS } from '../constants/analytics.constant';
import { CommonUtility } from './commonUtils';
import { ScsProductLines } from '../enums/symphony.enum';

export const HeaderUtil = {
  /**
   * Format menu items inclusion
   * @param resComponents Header Menu items inclusion components
   * @returns Nav Menu item
   */
  formatMenuItemsInclusions(
    resComponents: IExperienceInclusionDetails[],
  ): INavMenuItem[] {
    return (resComponents || [])
      .sort((a, b) => +a.orderId - +b.orderId)
      .map(({ id, components, attributes }) => ({
        id,
        label: `lbl_menuitem_${id.toLowerCase()}`,
        analyticLabel: ANALYTIC_CMS[id.toLowerCase()],
        components: (components || [])
          .sort((a, b) => +a.orderId - +b.orderId)
          .map((comp) => ({
            id: comp.id,
            label: this.setLabel(comp.id),
            analyticLabel: ANALYTIC_CMS[comp.id.toLowerCase()],
            routerLink: comp.attributes?.find((attr) => attr.key === 'link')
              ?.value,
          })),
        routerLink:
          attributes?.find((attr) => attr.key === 'link')?.value || '',
      }));
  },

  /**
   * Set Label key
   * @param componentID component ID
   * @returns Label key
   */
  setLabel(componentID: string): string {
    let labelComponent = componentID.toLowerCase();
    if (labelComponent === 'movementshipments') {
      labelComponent =
        CommonUtility.getProductLine() === ScsProductLines.HLD
          ? 'movementshipments_healthcare'
          : 'movementshipments';
    }
    return `lbl_menuitem_${labelComponent}`;
  },
};
